import { CommonModule } from '@angular/common';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { GeocoderService } from './geocoding/geocoder.service';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { TileLayerDirective } from './ngx-leaflet-exts/tile-layer.directive';
import { GenericControlsLayerDirective } from './ngx-leaflet-exts/generic-controls.directive';
import { SingleShapeEditorDirective } from './ngx-leaflet-exts/single-shape-editor.directive';
import { AutoFocusDirective } from './ngx-leaflet-exts/auto-focus.directive';
import { HEREv8RoutingService } from './routing/lrm-here';
import { StopsLayerDirective } from './ngx-leaflet-exts/stops-layer.directive';
import { StopsService } from '../shared/stops/stops.service';

/**
 * Module that contains mototrax map components
 */
@NgModule({
  declarations: [
    TileLayerDirective,
    GenericControlsLayerDirective,
    SingleShapeEditorDirective,
    StopsLayerDirective,
    AutoFocusDirective,
  ],
  imports: [
    CommonModule,
    LeafletModule,
  ],
  exports: [
    LeafletModule,
    TileLayerDirective,
    GenericControlsLayerDirective,
    SingleShapeEditorDirective,
    StopsLayerDirective,
    AutoFocusDirective,
  ],
  providers: [
    GeocoderService,
    HEREv8RoutingService,
    StopsService,
  ],
})
export class MapModule {

  public static forRoot(): ModuleWithProviders<MapModule> {
    return {
      ngModule: MapModule,
      providers: [],
    };
  }

}
